import Crud from '../views/Fluxo/Crud'
import Entity from '../views/Fluxo/Add'
import Editor from '../views/Fluxo/Editor'

let routes = {
    path: '/fluxos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fluxos/add',
            name: 'NewFluxo',
            component: Entity
        },
        {
            path: '/fluxos/edit/:id?',
            name: 'EditFluxo',
            component: Entity
        },
        {
            path: '/fluxos/editor/:id',
            name: 'EditorFluxo',
            component: Editor,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Fluxos', to: '/fluxos' },
                    { text: 'Editor', active: true },
                ],
            },
        },
        {
            path: '/fluxos',
            name: 'list-fluxos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Fluxos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
